import React, { Component } from 'react';
import '../css/popup-message.css';

class PopupMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShown: false,
            message: ''
        }

        this.defaultCallbackOnClose = () => {};
        this.callbackOnClose = this.defaultCallbackOnClose();
    }

    render() {
        const { isShown, message } = this.state;
        const popupClassNameSuffix = isShown ? 'shown' : 'hidden';

        return (
            <div className={`popup-overlay-${popupClassNameSuffix}`} onClick={ () => this.closePopupBox() }>
                <div className={`popup-lightbox-${popupClassNameSuffix}`} onClick={ (e) => e.stopPropagation() }>
                    <div className='popup-message-text'>{ message }</div>
                    <button className='close-popup-btn' onClick={ () => this.closePopupBox() }>Close</button>
                </div>
            </div>
        )
    }

    closePopupBox() {
        this.setState({ isShown: false })

        if (this.callbackOnClose && typeof this.callbackOnClose === 'function') {
            this.callbackOnClose();
            this.callbackOnClose = this.defaultCallbackOnClose();
        }
    }

    alert(message, callbackOnClose) {
        this.setState({
            message,
            isShown: true
        })

        if (callbackOnClose) {
            this.callbackOnClose = callbackOnClose;
        }
    }
}


export default PopupMessage;


// WEBPACK FOOTER //
// ./src/components/popup-message.js